// extracted by mini-css-extract-plugin
export default {"separator":"Breadcrumb_separator__zHt9L","breadcrumb":"Breadcrumb_breadcrumb__rxCPw","contrast":"Breadcrumb_contrast__j4ILZ"};